import React, { useContext, useState } from "react";

import {
  ApiRoutes,
  FetchContext,
  HttpMethods,
  ToastContext,
} from "../../contexts";

import { useAggregatedState } from "../../../helpers";

export const CompetenzeContext = React.createContext(null);

const { Provider } = CompetenzeContext;

export const CompetenzeProvider = (props) => {
  const {
    showWarningMessage,
    showSuccessMessage,
    showErrorMessage,
    showLoadingMessage,
    closeLoadingMessage,
  } = useContext(ToastContext);
  const { fetchOk, fetchAuthorized } = useContext(FetchContext);
  const [state, setState] = useAggregatedState({
    competenze: null,
    deleteCompetenza: null,
  });

  const { competenze } = state;

  const [isLoadingCompetenze, setIsLoadingCompetenze] = useState(false);
  const getCompetenzeAsync = async (
    pageIndex = 0,
    pageSize = 100,
    term = null
  ) => {
    try {
      setIsLoadingCompetenze(true);
      const r = await fetchAuthorized(
        ApiRoutes.Competenza.GetCompetenze({ pageIndex, pageSize, term }),
        {
          method: HttpMethods.GET,
        }
      );
      const list = await r.json();
      list.result = list.result.map((e) => {
        return {
          ...e,
          inizioValidita: new Date(e.inizioValidita),
          fineValidita: e.fineValidita ? new Date(e.fineValidita) : null,
        };
      });
      setState({ competenze: list });
    } catch (e) {
      console.debug(e);
    } finally {
      setIsLoadingCompetenze(false);
    }
  };

  const [isDeletingCompetenza, setIsDeletingCompetenza] = useState(false);
  const deleteCompetenzaAsync = async (competenzaId) => {
    try {
      setIsDeletingCompetenza(true);

      if (window.confirm("Confermare la disabilità?")) {
        const r = await fetchAuthorized(
          ApiRoutes.Competenza.DeleteCompetenza({ competenzaId }),
          {
            method: HttpMethods.DELETE,
          }
        );
        const list = competenze.result;
        list.forEach(x => {
          if (x.id == competenzaId)
            x.fineValidita = new Date();
        });
        setState({
          competenze: {
            ...competenze, result: list
          }
        });
        showSuccessMessage(`Competenza con id ${competenzaId} disabilitata`);
      }
    } catch (e) {
      console.debug(e);
    } finally {
      setIsDeletingCompetenza(false);
    }
  };

  return (
    <Provider
      value={{
        state,
        setState,

        isLoadingCompetenze,
        getCompetenzeAsync,

        isDeletingCompetenza,
        deleteCompetenzaAsync,
      }}
    >
      {props.children}
    </Provider>
  );
};
